



































































import { Vue, Component, Prop } from "vue-property-decorator";
import { mapState } from "vuex";
// types
import { IState } from "@/store";
import { IUser } from "@/models/users";
import { BrandConfigKeys } from "@/data/constants";
import { ClientRoutes } from "@/data/enums/router";
import { CreateElement } from "vue";
import { DataModules } from "@/store/modules/data";

@Component({
  components: {
    "support-pin-view": () =>
      import("@/components/app/client/clientSupportPinView.vue")
  },
  computed: {
    ...mapState({
      showSupportPin(state: IState) {
        return state.brand.config[BrandConfigKeys.SUPPORT_PIN_ENABLED];
      },
      user: (state: IState) => state.user
    })
  }
})
export default class ClientAccountMenu extends Vue {
  // Props

  @Prop({ required: true })
  public routes!: Function;

  // Data

  public readonly showSupportPin!: boolean;
  public readonly user!: IUser;

  // Lifecycle methods

  public mounted() {
    this.$bus.$emit("scrollToTop");
  }

  public manageParentRelation() {
    if (!this.user?.parent_client_config) return Promise.resolve();
    return this.$store.dispatch(
      `data/${DataModules.CLIENTS_CHILD_ACCOUNTS}/openManageChildAccountModal`,
      {
        parent: this,
        props: {
          parentClient: this.user?.parent_client_config?.parent_client,
          childAccount: this.user?.parent_client_config,
          childClient: this.user
        },
        events: {
          success: () => this.$store.dispatch("auth/client/getUser")
        }
      }
    );
  }

  // Computed

  public get securitySettingsRoute() {
    return {
      name: ClientRoutes.ACCOUNT_SECURITY
    };
  }

  /**
   * @name showUsername
   * @desc Here we determine whether or not to show the client's username. If the
   * username is identical to their default email we won't show the username
   * field as it just adds duplicate data. */

  public get showUsername() {
    const { default_email, username } = this.user;
    if (default_email?.email === username) return false;
    return true;
  }

  public get accountType() {
    const {
      id: clientId,
      parent_client_config,
      child_client_configs_count
    } = this.user;
    // IS Child Account
    if (parent_client_config)
      return {
        render: (h: CreateElement) =>
          h(
            "i18n",
            {
              props: {
                path: "_sentence.related_accounts.child_of_parent"
              }
            },
            [
              h(
                "u-link",
                {
                  slot: "parent",
                  on: {
                    click: () => this.manageParentRelation()
                  }
                },
                parent_client_config?.parent_client?.public_name
              )
            ]
          )
      };
    // IS Parent Account
    if (child_client_configs_count)
      return {
        render: (h: CreateElement) =>
          h(
            "i18n",
            {
              props: {
                path: "_sentence.parent_with_children_link"
              }
            },
            [
              h(
                "u-link",
                {
                  slot: "childLink",
                  props: {
                    to: {
                      name: ClientRoutes.CHILD_ACCOUNTS,
                      params: { clientId }
                    }
                  }
                },
                [this.$tc("_plurals.children", child_client_configs_count)]
              )
            ]
          )
      };
    return null;
  }
}
